import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchForm from '../common/SearchForm';
import { Button } from '../common';
import MainWrapper from '../common/MainWrapper';

import {
  loadJsonOptions,
  submitSearchParams,
  resetSearchStatus,
  clearPinboard,
  clearAllFilters,
} from '../../redux/actions';

class Home extends Component {
  componentWillMount() {
    this.props.loadJsonOptions();
    this.props.resetSearchStatus();

    // console.log('pinboard ts', this.props.pinboard.lastUpdate);
    // console.log('pinboard data', this.props.pinboard);

    const now = Math.floor(Date.now() / 1000);
    const timePassed = ((now - this.props.pinboard.lastUpdate) / 60).toFixed(2); // Minutes

    // console.log('time passed', timePassed);

    if (timePassed >= 10080) {
      this.props.clearPinboard();
    }
  }

  componentDidMount() {
    const currentUrl = window.location.pathname;
    if (currentUrl === '/') {
      this.props.clearAllFilters();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchSuccess) {
      // console.log('GO TO RESULT PAGE');
      this.props.history.push('/search');
    }
  }

  clearAllFilters() {
    // console.log('function clearAllFilters');
    this.props.clearAllFilters();
    setTimeout(() => this.props.submitSearchParams('all'), 100);
  }

  render() {
    return (
      <MainWrapper>
        <div>
          <div className="text-center hlp-pt-30">
            <h1 className="hlp-mb-30">
              Database on Constitution&#8209;Building Processes{' '}
              <br className="visible-md visible-lg" />
              in Fragile Settings
            </h1>
            <div className="row">
              <div className="hlp-mb-30 x-hlp-ml-100 x-hlp-mr-100 col-xs-12">
                <div className="home-copy">
                  <p>
                    This database, aimed at both scholars and practitioners,
                    covers constitution-building processes in fragile settings
                    from 2001 to today, with over 200 data points for
                    each case. The database builds upon the Dataset on
                    Constitution Writing and Conflict Resolution (1975-2003)
                    developed by Professor Jennifer Widner of Princeton
                    University, which International IDEA has updated and
                    expanded.
                  </p>
                  <p>
                    Users may search the data using the regular or the advanced
                    search criteria below, with further filtering possible in
                    the results page. Each process is divided into stages for
                    ease of analysis.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <SearchForm layout="home" />

          <div className="form-block">
            <div className="field-wrapper">
              <label className="field-label" />
              <div className="field">
                <div className="buttons two-buttons">
                  <Button
                    classes="accent-invert"
                    onClick={() => {
                      this.props.submitSearchParams('all');
                    }}>
                    Show all
                  </Button>
                  <Button
                    classes="primary"
                    onClick={() => {
                      this.props.submitSearchParams(this.props.search_params);
                    }}>
                    Search
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    exportingInProgress: state.god.exportingInProgress,
    data: state.home.data,
    search_params: state.home.search_params,
    search_results: state.search.search_results,
    searchSuccess: state.search.searchSuccess,
    pinboard: state.pinboard.pinboard,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadJsonOptions,
      submitSearchParams,
      resetSearchStatus,
      clearPinboard,
      clearAllFilters
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
